
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.14.0
 * Query Engine version: e9771e62de70f79a5e1c604a2d7c8e2a0a874b48
 */
Prisma.prismaVersion = {
  client: "5.14.0",
  engine: "e9771e62de70f79a5e1c604a2d7c8e2a0a874b48"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.SmsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  country: 'country',
  phone: 'phone',
  code: 'code',
  sms_type: 'sms_type',
  state: 'state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastActivityAt: 'lastActivityAt',
  name: 'name',
  nickName: 'nickName',
  phone: 'phone',
  password: 'password',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  wxOpenId: 'wxOpenId',
  state: 'state'
};

exports.Prisma.UserPermissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  isAdmin: 'isAdmin',
  open: 'open',
  excel: 'excel',
  contentArticle: 'contentArticle',
  contentList: 'contentList',
  contentObject: 'contentObject',
  discountScore: 'discountScore',
  activityOnceRule: 'activityOnceRule',
  activityOnceRecord: 'activityOnceRecord',
  activitySigninRule: 'activitySigninRule',
  activitySigninRecord: 'activitySigninRecord',
  activityContest: 'activityContest',
  activityContestRecord: 'activityContestRecord',
  traderTradingTicketOrder: 'traderTradingTicketOrder',
  traderTrader: 'traderTrader',
  traderTradingTakeOver: 'traderTradingTakeOver',
  traderTradingTakeOverTask: 'traderTradingTakeOverTask',
  traderOrderTraderTradingTakeOverTask: 'traderOrderTraderTradingTakeOverTask',
  traderOrderTradingTakeOverTask: 'traderOrderTradingTakeOverTask',
  inviteInviter: 'inviteInviter',
  inviteInviteRelation: 'inviteInviteRelation',
  invitePayment: 'invitePayment',
  inviteInvestorRelation: 'inviteInvestorRelation',
  virtualTrading: 'virtualTrading',
  virtualTradingTicketOrderAll: 'virtualTradingTicketOrderAll',
  virtualTradingTicketOrderFinished: 'virtualTradingTicketOrderFinished',
  virtualProductTradingConfig: 'virtualProductTradingConfig',
  virtualProductTradingQuota: 'virtualProductTradingQuota',
  realTrading: 'realTrading',
  realTradingTicketOrderAll: 'realTradingTicketOrderAll',
  realTradingTicketOrderFinished: 'realTradingTicketOrderFinished',
  realProductTradingConfig: 'realProductTradingConfig',
  realProductTradingQuota: 'realProductTradingQuota',
  rulePlaceOrderRule: 'rulePlaceOrderRule',
  ruleControl: 'ruleControl',
  investorInvestor: 'investorInvestor',
  investorAccount: 'investorAccount',
  userBase: 'userBase',
  userAccountSerial: 'userAccountSerial',
  userAccountVerified: 'userAccountVerified',
  userInvitation: 'userInvitation',
  userPush: 'userPush',
  userAccount: 'userAccount',
  userUserRight: 'userUserRight',
  userPayOrder: 'userPayOrder',
  userWithdrawOrder: 'userWithdrawOrder',
  blackListAccount: 'blackListAccount',
  statisticsRegister: 'statisticsRegister',
  statisticsArticle: 'statisticsArticle',
  statisticsPayOrderWithdraw: 'statisticsPayOrderWithdraw',
  statisticsFund: 'statisticsFund',
  statisticsRealTraffic: 'statisticsRealTraffic',
  statisticsVirtualTraffic: 'statisticsVirtualTraffic',
  statisticsRealTransaction: 'statisticsRealTransaction',
  statisticsVirtualTransaction: 'statisticsVirtualTransaction',
  backgroundSignOut: 'backgroundSignOut',
  backgroundOperate: 'backgroundOperate',
  backgroundBusiness: 'backgroundBusiness',
  backgroundShareBonus: 'backgroundShareBonus',
  backgroundSwitch: 'backgroundSwitch',
  backgroundFeeRate: 'backgroundFeeRate',
  backgroundUserPermission: 'backgroundUserPermission'
};

exports.Prisma.UserRightScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  login: 'login',
  mimic: 'mimic',
  firmOffer: 'firmOffer',
  recharge: 'recharge',
  withdrawal: 'withdrawal'
};

exports.Prisma.InvestorScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isReal: 'isReal',
  accountName: 'accountName',
  fundAccount: 'fundAccount',
  financingInstitution: 'financingInstitution',
  guaranteeRatio: 'guaranteeRatio',
  availableContribution: 'availableContribution',
  financingGap: 'financingGap',
  ignoreGapRate: 'ignoreGapRate',
  userPositions: 'userPositions',
  merchantOffer: 'merchantOffer',
  remainingContribution: 'remainingContribution',
  unreconciled: 'unreconciled',
  transitBalance: 'transitBalance',
  cumulativeBalance: 'cumulativeBalance',
  profitLoss: 'profitLoss',
  objectProfitLoss: 'objectProfitLoss',
  qs: 'qs',
  ip: 'ip',
  port: 'port',
  yyb_id: 'yyb_id',
  login_mode: 'login_mode',
  pwd: 'pwd'
};

exports.Prisma.FlatRecordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  investorId: 'investorId',
  amount: 'amount'
};

exports.Prisma.RecommenderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  phone: 'phone',
  nickname: 'nickname',
  name: 'name',
  userId: 'userId',
  remark: 'remark',
  recommendTotal: 'recommendTotal',
  recommendCodeTotal: 'recommendCodeTotal',
  totalIncome: 'totalIncome',
  shareInfoFeeRate: 'shareInfoFeeRate',
  shareTDFeeRate: 'shareTDFeeRate',
  shareInvestorFeeRate: 'shareInvestorFeeRate',
  shareTotalRate: 'shareTotalRate',
  selfInfoFeeRate: 'selfInfoFeeRate',
  selfTDFeeRate: 'selfTDFeeRate',
  selfInvestorFeeRate: 'selfInvestorFeeRate',
  selfTotalRate: 'selfTotalRate',
  sharingMode: 'sharingMode',
  state: 'state'
};

exports.Prisma.RecommendCodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  recommenderId: 'recommenderId',
  code: 'code'
};

exports.Prisma.RecommendedRelationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  recommenderId: 'recommenderId',
  code: 'code',
  totalFee: 'totalFee',
  state: 'state'
};

exports.Prisma.RecommenderInvestorRelationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  investorId: 'investorId',
  recommenderId: 'recommenderId'
};

exports.Prisma.ReferralFeeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tradingId: 'tradingId',
  recommenderId: 'recommenderId',
  shareTotalFee: 'shareTotalFee',
  shareInfoFee: 'shareInfoFee',
  shareTDFee: 'shareTDFee',
  shareInvestorFee: 'shareInvestorFee',
  code: 'code',
  state: 'state'
};

exports.Prisma.PlaceOrderRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  total: 'total',
  defaultRule: 'defaultRule'
};

exports.Prisma.PlaceOrderRuleItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  placeOrderRuleId: 'placeOrderRuleId',
  recommenderId: 'recommenderId',
  weight: 'weight'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  accountType: 'accountType',
  accountState: 'accountState',
  verified: 'verified',
  balance: 'balance',
  freeze: 'freeze'
};

exports.Prisma.AccountSerialScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  accountId: 'accountId',
  accountSerialType: 'accountSerialType',
  category: 'category',
  tradingId: 'tradingId',
  removable_num: 'removable_num',
  freeze_num: 'freeze_num',
  current_left: 'current_left',
  variation_num: 'variation_num',
  remark: 'remark'
};

exports.Prisma.AccountRealnameAuthScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  idCard: 'idCard',
  userId: 'userId',
  idCardUrl: 'idCardUrl',
  state: 'state',
  msg: 'msg'
};

exports.Prisma.AccountVerifiedScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  accountId: 'accountId',
  name: 'name',
  bank: 'bank',
  bankCity: 'bankCity',
  bankCard: 'bankCard',
  idCard: 'idCard',
  verifiedState: 'verifiedState'
};

exports.Prisma.MemberInWorkspaceScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  workspaceId: 'workspaceId',
  role: 'role'
};

exports.Prisma.InvitationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  inviterId: 'inviterId',
  inviteeId: 'inviteeId',
  inviteNum: 'inviteNum',
  link: 'link',
  lottery: 'lottery'
};

exports.Prisma.PayOrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  payOrderId: 'payOrderId',
  payType: 'payType',
  payItem: 'payItem',
  payAmount: 'payAmount',
  goodsAmount: 'goodsAmount',
  payUrl: 'payUrl',
  h5Url: 'h5Url',
  extra: 'extra',
  userId: 'userId',
  timeout: 'timeout',
  state: 'state'
};

exports.Prisma.WithdrawOrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  withdrawOrderId: 'withdrawOrderId',
  withdrawAmount: 'withdrawAmount',
  workspaceId: 'workspaceId',
  h5Url: 'h5Url',
  extra: 'extra',
  accountId: 'accountId',
  timeout: 'timeout',
  state: 'state',
  accountVerifiedId: 'accountVerifiedId'
};

exports.Prisma.PayOrderWithdrawScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  payOrderAmount: 'payOrderAmount',
  payOrderCount: 'payOrderCount',
  accreditAmount: 'accreditAmount',
  accreditCount: 'accreditCount',
  withdrawAmount: 'withdrawAmount',
  withdrawCount: 'withdrawCount'
};

exports.Prisma.CreditRateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  action: 'action',
  rate: 'rate'
};

exports.Prisma.OnceRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  action: 'action',
  tips: 'tips',
  url: 'url',
  credit: 'credit',
  open: 'open'
};

exports.Prisma.OnceRecordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  recordNumber: 'recordNumber',
  reason: 'reason',
  recordType: 'recordType',
  credit: 'credit',
  remark: 'remark',
  userId: 'userId',
  open: 'open'
};

exports.Prisma.SigninRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  level1: 'level1',
  continuous1: 'continuous1',
  credit1: 'credit1',
  level2: 'level2',
  continuous2: 'continuous2',
  credit2: 'credit2',
  level3: 'level3',
  continuous3: 'continuous3',
  credit3: 'credit3',
  level4: 'level4',
  continuous4: 'continuous4',
  credit4: 'credit4',
  startTime: 'startTime',
  interval: 'interval',
  open: 'open'
};

exports.Prisma.SigninRecordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  recordNumber: 'recordNumber',
  reason: 'reason',
  recordType: 'recordType',
  credit: 'credit',
  remark: 'remark',
  userId: 'userId',
  open: 'open'
};

exports.Prisma.ContestScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  awardType: 'awardType',
  name: 'name',
  sourceUrl: 'sourceUrl',
  linkUrl: 'linkUrl',
  startTime: 'startTime',
  endTime: 'endTime',
  dayOpen: 'dayOpen',
  weekOpen: 'weekOpen',
  state: 'state'
};

exports.Prisma.ContestRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ruleType: 'ruleType',
  level: 'level',
  desc: 'desc',
  credit: 'credit',
  contestId: 'contestId'
};

exports.Prisma.ContestRecordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  recordNumber: 'recordNumber',
  reason: 'reason',
  recordType: 'recordType',
  credit: 'credit',
  remark: 'remark',
  userId: 'userId',
  open: 'open'
};

exports.Prisma.TradingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tradingNo: 'tradingNo',
  isReal: 'isReal',
  supportTD: 'supportTD',
  autoTD: 'autoTD',
  userId: 'userId',
  productId: 'productId',
  objectId: 'objectId',
  createType: 'createType',
  createOtherId: 'createOtherId',
  tradingState: 'tradingState',
  settledTime: 'settledTime',
  settledMethod: 'settledMethod',
  tradeNumber: 'tradeNumber',
  tradeQuota: 'tradeQuota',
  infoCharge: 'infoCharge',
  creditCharge: 'creditCharge',
  currentChargeDay: 'currentChargeDay',
  totalChargeDay: 'totalChargeDay',
  deferralFee: 'deferralFee',
  stopLossLine: 'stopLossLine',
  stopLossPrice: 'stopLossPrice',
  performanceRate: 'performanceRate',
  performanceNumber: 'performanceNumber',
  performanceRealNumber: 'performanceRealNumber',
  performanceDeductible: 'performanceDeductible',
  performanceRealDeductible: 'performanceRealDeductible',
  selfStopWinRate: 'selfStopWinRate',
  selfStopWinPrice: 'selfStopWinPrice',
  selfStopLossRate: 'selfStopLossRate',
  selfStopLossPrice: 'selfStopLossPrice',
  expendableFund: 'expendableFund',
  portfolioNumber: 'portfolioNumber',
  portfolioValue: 'portfolioValue',
  averageCost: 'averageCost',
  averageCostPerShare: 'averageCostPerShare',
  averageRealizedPrice: 'averageRealizedPrice',
  remainingFunds: 'remainingFunds',
  yield: 'yield',
  profitLoss: 'profitLoss',
  userProfit: 'userProfit',
  investorDivided: 'investorDivided',
  investorLoss: 'investorLoss',
  tradingFeeIn: 'tradingFeeIn',
  tradingFeeOut: 'tradingFeeOut',
  profitLossTotal: 'profitLossTotal',
  tradingProfit: 'tradingProfit'
};

exports.Prisma.TraderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  spot: 'spot',
  futures: 'futures',
  seeMore: 'seeMore'
};

exports.Prisma.TradingTakeOverScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  takeNo: 'takeNo',
  tradingId: 'tradingId',
  investorId: 'investorId',
  takeTime: 'takeTime',
  takeNumber: 'takeNumber',
  takePrice: 'takePrice',
  takeAmount: 'takeAmount',
  remark: 'remark',
  status: 'status'
};

exports.Prisma.TradingTakeOverTaskScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  takeoverId: 'takeoverId',
  traderId: 'traderId',
  investorId: 'investorId',
  remainNumber: 'remainNumber',
  allocationTime: 'allocationTime',
  completeTime: 'completeTime',
  status: 'status'
};

exports.Prisma.TradingTakeOverTaskDetailScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ticketOrder: 'ticketOrder',
  takeoverTaskId: 'takeoverTaskId',
  objectId: 'objectId',
  traderId: 'traderId',
  entrustMethod: 'entrustMethod',
  entrustDirection: 'entrustDirection',
  entrustNumber: 'entrustNumber',
  entrustPrice: 'entrustPrice',
  volumeNumber: 'volumeNumber',
  volumePrice: 'volumePrice',
  volumeTotal: 'volumeTotal',
  fee: 'fee',
  stampDuty: 'stampDuty',
  transferFee: 'transferFee',
  sumAmount: 'sumAmount',
  tickerState: 'tickerState'
};

exports.Prisma.TradingDeferralScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tradingId: 'tradingId',
  payTime: 'payTime',
  tDay: 'tDay',
  selectDays: 'selectDays',
  frozenAmount: 'frozenAmount',
  payMethod: 'payMethod'
};

exports.Prisma.TradingOperatingRecordScalarFieldEnum = {
  iid: 'iid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tradingId: 'tradingId',
  action: 'action',
  target: 'target',
  remark: 'remark',
  operatorId: 'operatorId'
};

exports.Prisma.TradingFundSnapshotScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tradingId: 'tradingId',
  accountName: 'accountName',
  financingInstitution: 'financingInstitution',
  availableContribution: 'availableContribution',
  financingGap: 'financingGap',
  ignoreGapRate: 'ignoreGapRate',
  leftContribution: 'leftContribution',
  weight: 'weight',
  snapshotState: 'snapshotState',
  detail: 'detail'
};

exports.Prisma.TradingTicketOrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  operatorId: 'operatorId',
  ticketNo: 'ticketNo',
  tradingId: 'tradingId',
  userId: 'userId',
  productId: 'productId',
  entrustMethod: 'entrustMethod',
  entrustDirection: 'entrustDirection',
  property: 'property',
  entrustNumber: 'entrustNumber',
  entrustPrice: 'entrustPrice',
  volumeNumber: 'volumeNumber',
  volumePrice: 'volumePrice',
  volumeTotal: 'volumeTotal',
  fee: 'fee',
  stampDuty: 'stampDuty',
  transferFee: 'transferFee',
  sumAmount: 'sumAmount',
  tickerState: 'tickerState'
};

exports.Prisma.PracticalTradingTicketOrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  operatorId: 'operatorId',
  ticketNo: 'ticketNo',
  tradingId: 'tradingId',
  userId: 'userId',
  productId: 'productId',
  investorId: 'investorId',
  entrustMethod: 'entrustMethod',
  entrustDirection: 'entrustDirection',
  property: 'property',
  entrustNumber: 'entrustNumber',
  entrustPrice: 'entrustPrice',
  volumeNumber: 'volumeNumber',
  volumePrice: 'volumePrice',
  volumeTotal: 'volumeTotal',
  fee: 'fee',
  stampDuty: 'stampDuty',
  transferFee: 'transferFee',
  sumAmount: 'sumAmount',
  tickerState: 'tickerState'
};

exports.Prisma.WorkspaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  icon: 'icon',
  isOnline: 'isOnline'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  productShowId: 'productShowId',
  version: 'version',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  icon: 'icon',
  banner: 'banner',
  name: 'name',
  short: 'short',
  description: 'description',
  status: 'status',
  isReal: 'isReal',
  workspaceId: 'workspaceId',
  order: 'order',
  isShow: 'isShow',
  supportTD: 'supportTD',
  blacklistOpened: 'blacklistOpened',
  tradeTotal: 'tradeTotal'
};

exports.Prisma.ProductRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productId: 'productId',
  content: 'content'
};

exports.Prisma.ProductWhiteListScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productId: 'productId',
  name: 'name',
  match: 'match'
};

exports.Prisma.TradeBlackListScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  match: 'match',
  filterType: 'filterType',
  remark: 'remark'
};

exports.Prisma.ProductTradingConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productId: 'productId',
  isReal: 'isReal',
  feeRate: 'feeRate',
  deferralFeeRate: 'deferralFeeRate',
  investorFeePercent: 'investorFeePercent',
  stopLossToBrokerPercent: 'stopLossToBrokerPercent',
  objectBuyingUpLimitPercent: 'objectBuyingUpLimitPercent',
  objectBuyingDownLimitPercent: 'objectBuyingDownLimitPercent',
  userTradeLimit: 'userTradeLimit',
  online: 'online',
  productMarginRates: 'productMarginRates',
  marketValue: 'marketValue',
  canCreateStart: 'canCreateStart',
  canCreateEnd: 'canCreateEnd',
  canTradeStart: 'canTradeStart',
  canTradeEnd: 'canTradeEnd',
  maxSurvival: 'maxSurvival',
  liquidationTime: 'liquidationTime',
  allowStopLoss: 'allowStopLoss',
  creditINfoRate: 'creditINfoRate',
  creditMarginRate: 'creditMarginRate',
  enableStopLossToBroker: 'enableStopLossToBroker'
};

exports.Prisma.ProductTradingQuotaScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isReal: 'isReal',
  productId: 'productId',
  totalQuota: 'totalQuota',
  usedQuota: 'usedQuota',
  online: 'online'
};

exports.Prisma.ProductBoardScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productId: 'productId',
  boardId: 'boardId'
};

exports.Prisma.WorkspacePicScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workspaceId: 'workspaceId',
  sourceUrl: 'sourceUrl',
  column: 'column',
  title: 'title',
  link: 'link',
  order: 'order',
  isShow: 'isShow',
  operatorId: 'operatorId'
};

exports.Prisma.WorkspaceTextScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workspaceId: 'workspaceId',
  column: 'column',
  title: 'title',
  link: 'link',
  order: 'order',
  isShow: 'isShow',
  operatorId: 'operatorId'
};

exports.Prisma.WorkspaceListScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workspaceId: 'workspaceId',
  column: 'column',
  list_id: 'list_id',
  list_title: 'list_title',
  order: 'order',
  isShow: 'isShow',
  operatorId: 'operatorId'
};

exports.Prisma.WorkspacePushScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workspaceId: 'workspaceId',
  state: 'state',
  content: 'content',
  link: 'link',
  total: 'total',
  sent_num: 'sent_num',
  all: 'all',
  operatorId: 'operatorId'
};

exports.Prisma.WorkspacePushItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  pushId: 'pushId',
  state: 'state'
};

exports.Prisma.ArticleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  image: 'image',
  linkUrl: 'linkUrl',
  content: 'content',
  articleArea: 'articleArea',
  isShow: 'isShow',
  readCount: 'readCount'
};

exports.Prisma.ListScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  content: 'content',
  isShow: 'isShow'
};

exports.Prisma.ListObjectScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  objectId: 'objectId',
  listId: 'listId',
  order: 'order',
  isShow: 'isShow'
};

exports.Prisma.StockObjectScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  objectName: 'objectName',
  objectCode: 'objectCode',
  jys: 'jys'
};

exports.Prisma.UserStockObjectScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  objectId: 'objectId',
  order: 'order'
};

exports.Prisma.StockIndexScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  dm: 'dm',
  mc: 'mc',
  jys: 'jys',
  order: 'order'
};

exports.Prisma.BoardScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  code: 'code',
  name: 'name',
  type1: 'type1',
  type2: 'type2',
  level: 'level',
  pCode: 'pCode',
  pName: 'pName',
  isLeaf: 'isLeaf',
  isFutures: 'isFutures'
};

exports.Prisma.OperationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  operatorId: 'operatorId',
  operationType: 'operationType',
  objectId: 'objectId'
};

exports.Prisma.DividendScalarFieldEnum = {
  id: 'id',
  stockCode: 'stockCode',
  date: 'date',
  type: 'type',
  beforeFloat: 'beforeFloat',
  beforeTotal: 'beforeTotal',
  afterFloat: 'afterFloat',
  afterTotal: 'afterTotal',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ShareBonusScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  objectId: 'objectId',
  sdate: 'sdate',
  give: 'give',
  change: 'change',
  send: 'send',
  line: 'line',
  cdate: 'cdate',
  edate: 'edate',
  hdate: 'hdate',
  state: 'state'
};

exports.Prisma.ShareBonusTradingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  shareBonusId: 'shareBonusId',
  tradingId: 'tradingId',
  tradeNumber: 'tradeNumber',
  give: 'give',
  change: 'change',
  send: 'send'
};

exports.Prisma.UserMediaScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  fileName: 'fileName',
  url: 'url',
  preview: 'preview',
  workspaceId: 'workspaceId',
  size: 'size',
  mimeType: 'mimeType',
  mediaFrom: 'mediaFrom',
  mediaType: 'mediaType',
  usedArea: 'usedArea',
  processState: 'processState'
};

exports.Prisma.QrCodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  qr_id: 'qr_id',
  open_id: 'open_id',
  event: 'event',
  state: 'state'
};

exports.Prisma.FeeRateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  feeType: 'feeType',
  feeRate: 'feeRate',
  min: 'min',
  max: 'max',
  remark: 'remark'
};

exports.Prisma.PlanLevelScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  price: 'price',
  workspace_no: 'workspace_no',
  product_no: 'product_no',
  members_no: 'members_no',
  pay_template_no: 'pay_template_no',
  buz_template_no: 'buz_template_no',
  chat_no: 'chat_no',
  ai_chat_no: 'ai_chat_no',
  plugin: 'plugin',
  valid_day: 'valid_day'
};

exports.Prisma.WorkspaceConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  logo: 'logo',
  slogan: 'slogan',
  desc: 'desc',
  slogan_title: 'slogan_title',
  slogan_desc: 'slogan_desc',
  feature1_title: 'feature1_title',
  feature1_desc: 'feature1_desc',
  feature2_title: 'feature2_title',
  feature2_desc: 'feature2_desc',
  feature3_title: 'feature3_title',
  feature3_desc: 'feature3_desc',
  feature4_title: 'feature4_title',
  feature4_desc: 'feature4_desc',
  knowledge_title: 'knowledge_title',
  knowledge_desc: 'knowledge_desc',
  knowledge_link: 'knowledge_link',
  knowledge_image: 'knowledge_image',
  intro_title: 'intro_title',
  intro_desc: 'intro_desc',
  intro_link: 'intro_link',
  intro_image: 'intro_image',
  every_title: 'every_title',
  every_desc: 'every_desc',
  tool_title: 'tool_title',
  tool_desc: 'tool_desc',
  tool_link: 'tool_link',
  tool_image: 'tool_image',
  clientele_title: 'clientele_title',
  clientele_desc: 'clientele_desc',
  company: 'company',
  company_address: 'company_address',
  about_url: 'about_url',
  disclaimer_url: 'disclaimer_url',
  primary_url: 'primary_url',
  qrcode_url: 'qrcode_url',
  support_email: 'support_email',
  icp: 'icp',
  wangan: 'wangan',
  workspaceId: 'workspaceId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.UserState = exports.$Enums.UserState = {
  NORMAL: 'NORMAL',
  AGENT: 'AGENT',
  CHANNEL: 'CHANNEL',
  TRADER: 'TRADER',
  ADMIN: 'ADMIN',
  INVALID: 'INVALID'
};

exports.RecommenderSharingMode = exports.$Enums.RecommenderSharingMode = {
  Normal: 'Normal',
  Total: 'Total'
};

exports.RecommenderState = exports.$Enums.RecommenderState = {
  Online: 'Online',
  Offline: 'Offline'
};

exports.RecommendedRelationState = exports.$Enums.RecommendedRelationState = {
  Normal: 'Normal',
  Finished: 'Finished',
  Invalid: 'Invalid'
};

exports.ReferralFeeState = exports.$Enums.ReferralFeeState = {
  Normal: 'Normal',
  Divided: 'Divided'
};

exports.AccountType = exports.$Enums.AccountType = {
  Earnings: 'Earnings',
  Virtual: 'Virtual',
  Credit: 'Credit'
};

exports.AccountState = exports.$Enums.AccountState = {
  Normal: 'Normal',
  Banned: 'Banned'
};

exports.AccountSerialType = exports.$Enums.AccountSerialType = {
  Recharge: 'Recharge',
  RechargeAssistance: 'RechargeAssistance',
  InfoCharge: 'InfoCharge',
  Settled: 'Settled',
  PerformanceDeductible: 'PerformanceDeductible',
  Earnest: 'Earnest',
  Withdraw: 'Withdraw',
  TDFee: 'TDFee',
  TDRefund: 'TDRefund',
  TransferFee: 'TransferFee',
  Fee: 'Fee',
  StampDuty: 'StampDuty',
  Compensation: 'Compensation',
  InvestorProfitLoss: 'InvestorProfitLoss',
  Dividend: 'Dividend',
  VirtualRegister: 'VirtualRegister',
  VirtualDistribution: 'VirtualDistribution',
  VirtualDeduction: 'VirtualDeduction',
  VirtualInfoCharge: 'VirtualInfoCharge',
  VirtualPerformanceDeductible: 'VirtualPerformanceDeductible',
  VirtualSettled: 'VirtualSettled',
  VirtualEarnest: 'VirtualEarnest',
  VirtualTDFee: 'VirtualTDFee',
  VirtualTDRefund: 'VirtualTDRefund',
  VirtualTransferFee: 'VirtualTransferFee',
  VirtualFee: 'VirtualFee',
  VirtualStampDuty: 'VirtualStampDuty',
  VirtualCompensation: 'VirtualCompensation',
  VirtualInvestorProfitLoss: 'VirtualInvestorProfitLoss',
  VirtualDividend: 'VirtualDividend',
  CreditRecharge: 'CreditRecharge',
  CreditExchange: 'CreditExchange',
  CreditRewart: 'CreditRewart',
  TradeCompensation: 'TradeCompensation',
  TradeCover: 'TradeCover',
  RedPacketDistribution: 'RedPacketDistribution',
  RedPacketDeduction: 'RedPacketDeduction',
  ActivityGiveaway: 'ActivityGiveaway',
  ExpenseDeduction: 'ExpenseDeduction',
  PerformanceDeduction: 'PerformanceDeduction',
  LossDeduction: 'LossDeduction',
  CommunityConsumption: 'CommunityConsumption',
  ActivityDeduction: 'ActivityDeduction',
  Other: 'Other'
};

exports.AccountSerialCategory = exports.$Enums.AccountSerialCategory = {
  NONE: 'NONE',
  BUY: 'BUY',
  SELL: 'SELL'
};

exports.AccountRealnameAuthState = exports.$Enums.AccountRealnameAuthState = {
  Waiting: 'Waiting',
  Success: 'Success',
  Reject: 'Reject'
};

exports.AccountVerifiedState = exports.$Enums.AccountVerifiedState = {
  Waiting: 'Waiting',
  Success: 'Success',
  Reject: 'Reject'
};

exports.WorkspaceRole = exports.$Enums.WorkspaceRole = {
  ADMIN: 'ADMIN',
  AGENT: 'AGENT',
  CHANNEL: 'CHANNEL',
  EXPERT: 'EXPERT',
  MEMBER: 'MEMBER',
  GUEST: 'GUEST'
};

exports.PayType = exports.$Enums.PayType = {
  TenPay: 'TenPay',
  WeChat: 'WeChat',
  Alipay: 'Alipay',
  Bank: 'Bank'
};

exports.PayItem = exports.$Enums.PayItem = {
  TRIAL: 'TRIAL',
  BASE: 'BASE',
  PRO: 'PRO',
  BUSINESS: 'BUSINESS',
  CUSTOM: 'CUSTOM',
  TEMPLATE: 'TEMPLATE',
  PROXY: 'PROXY',
  CHANNEL: 'CHANNEL',
  CDKEY: 'CDKEY'
};

exports.PayOrderState = exports.$Enums.PayOrderState = {
  Waiting: 'Waiting',
  Paying: 'Paying',
  Success: 'Success',
  Failed: 'Failed',
  Timeout: 'Timeout',
  Refund: 'Refund',
  Closed: 'Closed'
};

exports.WithdrawOrderState = exports.$Enums.WithdrawOrderState = {
  Waiting: 'Waiting',
  Withdrawing: 'Withdrawing',
  Success: 'Success',
  Failed: 'Failed',
  Timeout: 'Timeout',
  Closed: 'Closed'
};

exports.OnceRecordType = exports.$Enums.OnceRecordType = {
  Credit: 'Credit',
  Cash: 'Cash',
  RedPacket: 'RedPacket'
};

exports.SigninRecordType = exports.$Enums.SigninRecordType = {
  Credit: 'Credit',
  Cash: 'Cash',
  RedPacket: 'RedPacket'
};

exports.AwardType = exports.$Enums.AwardType = {
  Credit: 'Credit',
  Cash: 'Cash',
  RedPacket: 'RedPacket'
};

exports.ContestState = exports.$Enums.ContestState = {
  Upcoming: 'Upcoming',
  Live: 'Live',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
  Postponed: 'Postponed',
  Interrupted: 'Interrupted'
};

exports.ContestRuleType = exports.$Enums.ContestRuleType = {
  Day: 'Day',
  Week: 'Week'
};

exports.ContestRecordType = exports.$Enums.ContestRecordType = {
  Credit: 'Credit',
  Cash: 'Cash',
  RedPacket: 'RedPacket'
};

exports.TradeCreateType = exports.$Enums.TradeCreateType = {
  New: 'New',
  Other: 'Other'
};

exports.TradingState = exports.$Enums.TradingState = {
  Ongoing: 'Ongoing',
  Settled: 'Settled',
  InLiquidation: 'InLiquidation'
};

exports.TradeSettledMethod = exports.$Enums.TradeSettledMethod = {
  Normal: 'Normal',
  StopWin: 'StopWin',
  StopLoss: 'StopLoss',
  Liquidation: 'Liquidation',
  Enforcement: 'Enforcement'
};

exports.TakeOverStatus = exports.$Enums.TakeOverStatus = {
  NEW: 'NEW',
  ALLOCATED: 'ALLOCATED'
};

exports.TakeOverTaskStatus = exports.$Enums.TakeOverTaskStatus = {
  UN_FINISHED: 'UN_FINISHED',
  PROCESSING: 'PROCESSING',
  FINISHED: 'FINISHED',
  RECYCLED: 'RECYCLED'
};

exports.TickerOrderEntrust = exports.$Enums.TickerOrderEntrust = {
  MarketPrice: 'MarketPrice',
  Immediately: 'Immediately',
  Appointment: 'Appointment'
};

exports.TickerOrderDirection = exports.$Enums.TickerOrderDirection = {
  Buy: 'Buy',
  Sell: 'Sell'
};

exports.TickerOrderState = exports.$Enums.TickerOrderState = {
  OpenOrder: 'OpenOrder',
  Entrusted: 'Entrusted',
  FullyExecuted: 'FullyExecuted',
  PartiallyFilled: 'PartiallyFilled',
  Cancelled: 'Cancelled',
  PartialRevocation: 'PartialRevocation',
  Revoked: 'Revoked'
};

exports.TradePayMethod = exports.$Enums.TradePayMethod = {
  VirtualAccount: 'VirtualAccount',
  EarningsAccount: 'EarningsAccount',
  Other: 'Other'
};

exports.TradingFundSnapshotState = exports.$Enums.TradingFundSnapshotState = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};

exports.TickerOrderProperty = exports.$Enums.TickerOrderProperty = {
  Normal: 'Normal',
  Splitting: 'Splitting',
  BrokersReturn: 'BrokersReturn',
  Transfer: 'Transfer'
};

exports.ProductStatus = exports.$Enums.ProductStatus = {
  Init: 'Init',
  Normal: 'Normal',
  Band: 'Band'
};

exports.TradeBlackType = exports.$Enums.TradeBlackType = {
  WILDCARD: 'WILDCARD',
  CODE: 'CODE'
};

exports.WorkspacePicColumn = exports.$Enums.WorkspacePicColumn = {
  HOME_BANNER: 'HOME_BANNER',
  HOME_ACTIVE: 'HOME_ACTIVE',
  PLAYGROUND_BANNER: 'PLAYGROUND_BANNER',
  PLAYGROUND_SIMULATION: 'PLAYGROUND_SIMULATION',
  PLAYGROUND_SIMULATION_AREA: 'PLAYGROUND_SIMULATION_AREA',
  PLAYGROUND_ACTIVE: 'PLAYGROUND_ACTIVE',
  HELP_CENTER: 'HELP_CENTER'
};

exports.WorkspaceTextColumn = exports.$Enums.WorkspaceTextColumn = {
  HELP_CENTER: 'HELP_CENTER',
  ACTIVITY_AC: 'ACTIVITY_AC',
  LINKAGE: 'LINKAGE',
  SIGNIN: 'SIGNIN',
  RULE: 'RULE'
};

exports.WorkspaceListColumn = exports.$Enums.WorkspaceListColumn = {
  FIRST: 'FIRST',
  SECOND: 'SECOND',
  INDEX_PAGE: 'INDEX_PAGE',
  HOT_SEARCH: 'HOT_SEARCH'
};

exports.WorkspacePushState = exports.$Enums.WorkspacePushState = {
  INIT: 'INIT',
  SENDING: 'SENDING',
  SENT: 'SENT',
  INVALID: 'INVALID'
};

exports.WorkspacePushItemState = exports.$Enums.WorkspacePushItemState = {
  INIT: 'INIT',
  PENDING: 'PENDING',
  SENT: 'SENT',
  READ: 'READ',
  NOT_EXIST: 'NOT_EXIST',
  INVALID: 'INVALID'
};

exports.ArticleArea = exports.$Enums.ArticleArea = {
  QA: 'QA',
  ANNOUNCE: 'ANNOUNCE'
};

exports.OperationType = exports.$Enums.OperationType = {
  PRODUCT: 'PRODUCT',
  PIC: 'PIC',
  TEXT: 'TEXT',
  LIST: 'LIST'
};

exports.ShareBonusState = exports.$Enums.ShareBonusState = {
  UNSHARED: 'UNSHARED',
  INIT: 'INIT',
  REGISTER: 'REGISTER',
  SHARED: 'SHARED',
  OTHER: 'OTHER'
};

exports.UserMediaFrom = exports.$Enums.UserMediaFrom = {
  UPLOAD: 'UPLOAD',
  COLLECT: 'COLLECT',
  AI_CREATED: 'AI_CREATED'
};

exports.UserMediaType = exports.$Enums.UserMediaType = {
  PDF: 'PDF',
  IMAGE: 'IMAGE',
  PPT: 'PPT',
  WORD: 'WORD',
  OTHER: 'OTHER'
};

exports.UserMediaUsedArea = exports.$Enums.UserMediaUsedArea = {
  EDITOR: 'EDITOR'
};

exports.UserMediaProcessState = exports.$Enums.UserMediaProcessState = {
  IDLE: 'IDLE',
  WAITING: 'WAITING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  INVALID: 'INVALID'
};

exports.FeeRateType = exports.$Enums.FeeRateType = {
  VirtualFee: 'VirtualFee',
  Fee: 'Fee',
  Transfer: 'Transfer',
  StampDuty: 'StampDuty'
};

exports.Prisma.ModelName = {
  Sms: 'Sms',
  Session: 'Session',
  User: 'User',
  UserPermission: 'UserPermission',
  UserRight: 'UserRight',
  Investor: 'Investor',
  FlatRecord: 'FlatRecord',
  Recommender: 'Recommender',
  RecommendCode: 'RecommendCode',
  RecommendedRelation: 'RecommendedRelation',
  RecommenderInvestorRelation: 'RecommenderInvestorRelation',
  ReferralFee: 'ReferralFee',
  PlaceOrderRule: 'PlaceOrderRule',
  PlaceOrderRuleItem: 'PlaceOrderRuleItem',
  Account: 'Account',
  AccountSerial: 'AccountSerial',
  AccountRealnameAuth: 'AccountRealnameAuth',
  AccountVerified: 'AccountVerified',
  MemberInWorkspace: 'MemberInWorkspace',
  Invitation: 'Invitation',
  PayOrder: 'PayOrder',
  WithdrawOrder: 'WithdrawOrder',
  PayOrderWithdraw: 'PayOrderWithdraw',
  CreditRate: 'CreditRate',
  OnceRule: 'OnceRule',
  OnceRecord: 'OnceRecord',
  SigninRule: 'SigninRule',
  SigninRecord: 'SigninRecord',
  Contest: 'Contest',
  ContestRule: 'ContestRule',
  ContestRecord: 'ContestRecord',
  Trading: 'Trading',
  Trader: 'Trader',
  TradingTakeOver: 'TradingTakeOver',
  TradingTakeOverTask: 'TradingTakeOverTask',
  TradingTakeOverTaskDetail: 'TradingTakeOverTaskDetail',
  TradingDeferral: 'TradingDeferral',
  TradingOperatingRecord: 'TradingOperatingRecord',
  TradingFundSnapshot: 'TradingFundSnapshot',
  TradingTicketOrder: 'TradingTicketOrder',
  PracticalTradingTicketOrder: 'PracticalTradingTicketOrder',
  Workspace: 'Workspace',
  Product: 'Product',
  ProductRule: 'ProductRule',
  ProductWhiteList: 'ProductWhiteList',
  TradeBlackList: 'TradeBlackList',
  ProductTradingConfig: 'ProductTradingConfig',
  ProductTradingQuota: 'ProductTradingQuota',
  ProductBoard: 'ProductBoard',
  WorkspacePic: 'WorkspacePic',
  WorkspaceText: 'WorkspaceText',
  WorkspaceList: 'WorkspaceList',
  WorkspacePush: 'WorkspacePush',
  WorkspacePushItem: 'WorkspacePushItem',
  Article: 'Article',
  List: 'List',
  ListObject: 'ListObject',
  StockObject: 'StockObject',
  UserStockObject: 'UserStockObject',
  StockIndex: 'StockIndex',
  Board: 'Board',
  Operation: 'Operation',
  Dividend: 'Dividend',
  ShareBonus: 'ShareBonus',
  ShareBonusTrading: 'ShareBonusTrading',
  UserMedia: 'UserMedia',
  QrCode: 'QrCode',
  FeeRate: 'FeeRate',
  PlanLevel: 'PlanLevel',
  WorkspaceConfig: 'WorkspaceConfig'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
